import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/git/order-app-2/layouts/default.vue").then(m => m.default || m))
}